import Swiper from 'swiper/core';
import { Navigation, FreeMode } from 'swiper/modules';
import loaded from '@/scripts/helpers/loaded';

const initSliders = () => {
    const sliders = Array.from(document.querySelectorAll('.slider--js__brands'));
    if (!sliders) {
        return;
    }

    if (!sliders.length) {
        return;
    }

    sliders?.forEach((slider) => {
        new Swiper(slider, {
            slidesPerView: "auto",
            effect: "fade",
            allowTouchMove: true,
            freeMode: false,
            loop: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: false,
            modules: [Navigation, FreeMode]
        });

        slider.style.opacity = '1';
    });

};

loaded( () => {
    const elements = document.querySelectorAll('[data-brand-icons]');
    if (!elements) {
        return;
    }

    if (!elements.length) {
        return;
    }

    elements.forEach((parent) => {
        const url = '/pages/brands-global';

        fetch(url)
            .then(response => response.text())
            .then(data => {
                data = data.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
                
                const hideContentElement = parent.querySelector('.js__hide_content__brands');
                if (hideContentElement) {
                    hideContentElement.innerHTML += data;
                    const contentElement = hideContentElement.querySelector('.js__parent__content__brands');
                    if (contentElement) {
                        parent.innerHTML = contentElement.innerHTML;
                    }
                }

                initSliders();
            })
            .catch(error => {
                console.error('Error fetching brands content:', error);
            });
    });

});

loaded(initSliders);
